import React from "react";
import { useTranslation } from "react-i18next";
import { SelectList } from "@common/selectList";
import { ColumnIcon } from "../../columnIcon";
import { fixedColumns } from "../fixedColumns";
import { Props } from "./types";
import styles from "./styles.scss";

function AddColumn({ project, template, columns, setColumns }: Props) {
  const { t, i18n } = useTranslation();
  const currentLang =
    ["fr", "en"].find((lang) => new RegExp(lang, "i").test(i18n.language)) ||
    "fr";
  const options = [
    ...fixedColumns.map((key) => ({
      uuid: key,
      name: t(`wbs.columnNames.${key}`, key),
    })),
    ...template.map((criteria) => ({
      uuid: criteria.uuid,
      name:
        criteria.labels[currentLang as keyof typeof criteria.labels] ||
        criteria.name,
    })),
  ].filter(({ uuid }) => !columns.includes(uuid));

  return (
    <SelectList listClassName={styles.listRoot}>
      {() => ({
        input: (
          <div className={styles.input}>
            <p>{t("wbsConfiguration.addColumn")}</p>
          </div>
        ),
        list: (
          <div className={styles.list}>
            {options.map((option) => (
              <div
                key={option.uuid}
                className={styles.item}
                onClick={() => setColumns([...columns, option.uuid])}
              >
                <ColumnIcon
                  criteriaKey={option.uuid}
                  projectId={project.uuid}
                  className={styles.icon}
                />
                <p className={styles.name}>{option.name}</p>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { AddColumn };
